export class Toaster {
    id:string;
    timestamp:number;
    title?:string;
    content?:string;
}